import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
// import TextField from "@mui/material/TextField";
import TextField from '@mui/material/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      //transform: "translate(14px, 16px) scale(1)",
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      fontFamily: '"Source Sans Pro",sans-serif',
      height: "24px",
    },
    "& .MuiOutlinedInput-notchedOutline > legend": {
      maxWidth: "1000px",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
    // "& .MuiOutlinedInput-root": {
    //   color: "#FFFFFF",
    // },
    // "& .MuiOutlinedInput-root.Mui-focused": {
    //   color: "#000000"
    // },
  },
}));

export default function DateTimeInput(props) {
  const {
    inputTitle,
    dateInput,
    handleDateInputChange,
    name,
    specialType,
    isRequired,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.input}>
      {/* <text className={classes.inputTitle}>{inputTitle}</text> */}
      <TextField
        disabled={props.disabled}
        variant="outlined"
        id={`${inputTitle}-required-outlined-size-small`}
        label={inputTitle}
        type={specialType}
        style={{ margin: "2px 8px" }}
        // defaultValue={dateInput}
        name={name}
        value={dateInput}
        onChange={handleDateInputChange}
        className={classes.textField}
        required={isRequired}
      />
    </div>
  );
}

DateTimeInput.defaultProps = {
  specialType: "datetime-local",
  isRequired: false,
};

DateTimeInput.propTypes = {
  isRequired: PropTypes.bool,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
  specialType: PropTypes.any,
};
